import axios from 'axios';

import { API_URL, STORAGE_TOKEN_KEY, STORAGE_USER_KEY } from '../config';

const axiosClient = axios.create({
  baseURL: API_URL,
  headers: {
    Accept: 'application/json',
  },
});

// Adjunta el token Bearer guardado en localStorage a cada request
axiosClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem(STORAGE_TOKEN_KEY);
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Si el backend responde 401, se asume sesion expirada/invalida:
// se limpia el token y se redirige al login. Se excluye el propio
// endpoint de login para no interferir con errores de credenciales.
axiosClient.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;
    const requestUrl = error?.config?.url || '';
    const hadToken = Boolean(localStorage.getItem(STORAGE_TOKEN_KEY));
    const isAuthEndpoint = requestUrl.includes('/login') || requestUrl.includes('/register');

    if (status === 401 && hadToken && !isAuthEndpoint) {
      localStorage.removeItem(STORAGE_TOKEN_KEY);
      localStorage.removeItem(STORAGE_USER_KEY);

      // Notifica a la app (AuthContext) que la sesion se cerro
      window.dispatchEvent(new CustomEvent('pc:unauthorized'));

      if (window.location.pathname !== '/login') {
        window.location.href = '/login';
      }
    }

    return Promise.reject(error);
  }
);

export default axiosClient;
